export const config = {
  apiKey: "AIzaSyCdUyFE2Lgbcd2NMnCMIIge5n6MLDm84yE",
  projectId: "coffee-journal-v2",
  databaseURL: "https://coffee-journal-v2.firebaseio.com",
  authDomain: "coffee-journal-v2.firebaseapp.com",
  storageBucket: 'gs://coffee-journal-v2.appspot.com/'
};
